import { getDefaultDrills } from "../drill";

const NativeMode = {
  name: "native",
  drills: getDefaultDrills,
};

export default NativeMode;
